import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { mockupUrl, offerAnchor, productName } from '../data/content';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function FinalClose() {
  return <section className="bg-brand px-4 py-12 md:py-16" data-id="element-62" data-mp="n4asycocg3b3">
      <div className="mx-auto max-w-3xl text-center" data-id="element-63" data-mp="i5raim8yl9nh">
        <p className="text-[11px] font-black uppercase tracking-[.25em] text-gold-light md:text-xs" data-id="element-64" data-mp="i7c2c43w2ehn">One last question</p>
        <h2 className="mx-auto mt-3 max-w-2xl text-xl font-black uppercase leading-snug text-white md:text-3xl" data-id="element-65" data-mp="1atwv9900iynb">
          How much easier would your work be with everything already organized?
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm font-black uppercase tracking-wider text-gold-light md:text-base" data-id="element-66" data-mp="114dafxsqoupt">
          Techniques. Regions. Clinical sessions. Exercises. Assessments. Tools.
        </p>

        <OfferLink className="mx-auto mt-8 max-w-[260px]" href={offerAnchor} label={`${productName} offer`} data-id="element-67" data-mp="1ts91omzjhuf7">
          <img src={mockupUrl} alt={`${productName} 3D product mockup`} className="w-full object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-68" data-mp="nqdkm1yx0f1b" />
        </OfferLink>

        <div className="mt-6" data-id="element-69" data-mp="iym1udm03dlq">
          <Button href={offerAnchor} size="lg" subtext="5 Complete Volumes + 5 Practical Bonuses" data-id="element-70" data-mp="ixkeparpn0nn">
            Yes! I want the complete bundle
          </Button>
        </div>
        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-wide text-white/85" data-id="element-71" data-mp="906d2hag4gfe">
          <li className="flex items-center gap-1.5" data-id="element-72" data-mp="3r7cibeva41y9">
            <ZapIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-73" data-mp="3w547400mn7y8" /> Instant Digital Delivery
          </li>
          <li className="flex items-center gap-1.5" data-id="element-74" data-mp="1pe6anlltjtzh">
            <ShieldCheckIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-75" data-mp="1pclc7kwdvqwc" /> 7-Day Guarantee
          </li>
        </ul>
      </div>
    </section>;
}